<ion-content fullscreen="false">
  <div class="page-title">
    <ion-img
      *ngIf="ssoLoginType===EnumService.SSOLoginType.AZURE"
      src="./assets/icon/Azure_logo.png"
    ></ion-img>
    <ion-icon
      *ngIf="ssoLoginType===EnumService.SSOLoginType.OKTA"
      src="./assets/icon/Okta_logo.svg"
    ></ion-icon>
  </div>
  <p class="page-description">
    {{'PAGESPECIFIC_TEXT.CHECK_SSO_ENABLE.DESCRIPTION' | translate}}
  </p>

  <form class="input-form" [formGroup]="myForm">
    <div class="app-warning-component">
      <app-warning-component
        *ngIf="errorMsg && errorMsg.length>0"
        [message]="errorMsg"
      ></app-warning-component>
    </div>

    <ion-item class="email-item">
      <ion-label position="stacked"
        >{{'PAGESPECIFIC_TEXT.CHECK_SSO_ENABLE.EMAIL_ADDRESS' |
        translate}}</ion-label
      >
      <ion-input
        formControlName="email"
        autocapitalize="off"
        autocomplete="email"
        inputmode="email"
        [ngClass]="{'error': (isSubmitted && !myForm.controls.email.valid)}"
        [placeholder]="'PAGESPECIFIC_TEXT.CHECK_SSO_ENABLE.ENTER_EMAIL_ADDRESS' | translate"
        type="email"
      ></ion-input>
    </ion-item>
  </form>

  <ion-button expand="full" class="signin-btn" (click)="onSubmit()"
    >{{'PAGESPECIFIC_TEXT.CHECK_SSO_ENABLE.SIGN_IN' | translate}}</ion-button
  >
  <ion-button
    fill="clear"
    class="forgot-password-btn"
    routerLink="/login"
    routerDirection="back"
  >
    {{'PAGESPECIFIC_TEXT.CHECK_SSO_ENABLE.GO_TO_SIGN_IN' | translate}}
  </ion-button>
</ion-content>
